import React from "react";
import "../../../../css/Common/Components/Cards/CardProduct2PopUp.css";
import { useState } from "react";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";

/**
 * CardProduct2PopUp component displays a popup card with a title, content, and close functionality.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.title - The title displayed at the top of the popup.
 * @param {string} [props.content=""] - The main content displayed inside the popup.
 * @param {Function} props.onClick - Callback function invoked when the popup is closed (via close icon or button).
 *
 * @returns {JSX.Element} The rendered CardProduct2PopUp component.
 */
const CardProduct2PopUp = ({ title, content = "", onClick }) => {
  const [clicked, setClicked] = useState(false);

  return (
    <>
      <div
        className="Card-Product2-PopUp "
      >
        <div className="Card-Product2-PopUp-Header">
          <h2>{title}</h2>
          <div className="Close-Icon">
            <CloseIcon
              onClick={() => {
                onClick();
              }}
            />
          </div>
        </div>
        <div className="Card-Product2-PopUp-Content">
          <div className="Content-Large">{content}</div>
          <div
            className="Close-Button-PopUp"
            onClick={() => {
              onClick();
            }}
          >
            <div
              className="Content-SemiBold"
              onClick={() => {
                onClick();
              }}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardProduct2PopUp;
